import React from "react";
import TrainerCard from "../../components/TrainerCard/index";
import "./index.css";
import BookTrialClass from "../../components/Classes";
import image1 from "../../assets/t-image1.png";
import image2 from "../../assets/t-image2.jpg";

import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import tick from '../../assets/tick.png';
  const workoutDays = [
    {
      day: 'Monday',
     
      sessions: [
        { time: '7:00 AM - 7:30 AM', instructor: 'Faizan Ahmed' },
        { time: '8:00 AM - 8:30 AM', instructor: 'Khurram Shahzad' },
       
      ],
    },
    {
      day: 'Tuesday',
      
      sessions: [
        { time: '6:00 AM - 6:45 AM', instructor: 'Faizan Ahmed' },
        { time: '7:00 AM - 7:45 AM', instructor: 'Khurram Shahzad' },
       
      ],
    },
    {
      day: 'Wednesday',
     
      sessions: [
        { time: '7:00 AM - 7:30 AM', instructor: 'Faizan Ahmed' },
        { time: '8:00 AM - 8:30 AM', instructor: 'Khurram Shahzad' },
       
      ],
    },
    {
      day: 'Thursday',
      
      sessions: [
        { time: '6:30 AM - 7:00 AM', instructor: 'Faizan Ahmed' },
        { time: '7:30 AM - 8:00 AM', instructor: 'Khurram Shahzad' },
        
      ],
    },
    {
      day: 'Friday',
      
      sessions: [
        { time: '7:00 AM - 7:30 AM', instructor: 'Faizan Ahmed' },
        { time: '8:00 AM - 8:30 AM', instructor: 'Khurram Shahzad' },
 
      ],
    },
    {
      day: 'Saturday',
      
      sessions: [
        { time: '8:00 AM - 9:00 AM', instructor: 'Faizan Ahmed' },
        { time: '9:00 AM - 10:00 AM', instructor: 'Khurran Shahzad' },
       
      ],
    },
    {
      day: 'Sunday',
      
      sessions: [
        { time: 'All day', instructor: 'Self-directed' },
      ],
    },
  ];
  const sections = [
    {
      title: "About us",
      text: "Our aim is to promote a healthy lifestyle with our best Fitness Club in Karachi. The Trifit brand is futuristic and based on a hi-tech and smart fitness concept infused with a personal touch. Trifit is committed to promote physical and emotional well-being for everyone through our fitness Clubs and virtual fitness app, Trifit MUV and myTrifit.",
    },
    {
      title: "Mission",
      text: "To provide a communal wellness experience through an accessible network of world-class fitness clubs. To provide a communal wellness experience through an accessible network of world-class fitness clubs. To provide a communal wellness experience through an accessible network of world-class fitness clubs.",
    },
    {
      title: "Vision",
      text: "To inspire and steer society towards an active lifestyle, encourage people to exercise regularly and make healthy choices. To provide a communal wellness experience through an accessible network of world-class fitness clubs. To provide a communal wellness experience through an accessible network of world-class fitness clubs.",
    },
    
    {
      title: "Our Team",
      text: "Our aim is to promote a healthy lifestyle with our best Fitness Club in Karachi. The Trifit brand is futuristic and based on a hi-tech and smart fitness concept infused with a personal touch. Trifit is committed to promote physical and emotional well-being for everyone through our fitness Clubs and virtual fitness app, Trifit MUV and myTrifit.",
    },
  ];
 
function AboutUs() {
  return (

    
   <>
   <Header/>

    <div className="containers">
    <div >
      <div className="section-title text-center mt-4 mb-5">
        Mission, Vision & History
      </div>
      <div className="row">
        {sections.map((section, index) => (
          <div className="col-md-6 mb-4" key={index}>
            <div className="d-flex align-items-start">
             
              <img src={tick} width={40} height={40}  />
              <div>
                <div className="content-title fw-bold mb-2">{section.title}</div>
                <div className="content-text text-muted">{section.text}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
       
       <TrainerCard  />
       
       <div className="timeTable-Containers">
  <div className="title">
    <h1>WEEKLY WORKOUT</h1>
  </div>
  <div className="row">
    {workoutDays.map((day, index) => (
      <div className="col-12 col-md-6 col-lg-3 mb-4" key={index}>
        <div className="day-card">
          <div className="day-header">{day.day}</div>
          <div className="day-content">
            <ul>
              {day.sessions.map((session, idx) => (
                <li key={idx}>
                  Time: {session.time} | Instructor: {session.instructor}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    ))}
  </div>
       </div>

         <BookTrialClass/>
        
    </div>
    <Footer/>
   </>
  );
}

export default AboutUs;
